module.exports = __webpack_public_path__ + "Emotional-1404b6bd29e2e0293da20dbe3d49db51.png";